import { useGetPageTitle } from "@/hooks";
import { useT } from "@/i18n";
import { ButtonLink, IconFloatingQuestion } from "@/ui";

import { ErrorPage } from "./ErrorPage";

export const NotFoundPage = () => {
  const t = useT();
  const getPageTitle = useGetPageTitle();

  return (
    <ErrorPage
      icon={IconFloatingQuestion}
      title={t("general.components.notFoundPage.title")}
      description={t("general.components.notFoundPage.description")}
      actions={
        <ButtonLink href="/" size="lg">
          {t("general.components.notFoundPage.backToHome")}
        </ButtonLink>
      }
      documentTitle={getPageTitle(t("general.components.notFoundPage.documentTitle"))}
    />
  );
};
